import { createSlice,createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
const initialState={
    step:0,
    username:null
};
const passwordSlice=createSlice({
    name:"password",
    initialState,
    reducers:{
        increment:(state)=>{
            if(state.step<2 && state.step>=0){
                state.step++;
            }
        },
        backToFirst:(state)=>{
            state.step=0;
        },
        setStep:(state,action:PayloadAction<number>)=>{
            state.step=action.payload;
        },
        _setUsername:(state,action:PayloadAction<any>)=>{
            state.username=action.payload;
        }
    }
})
export const { increment,backToFirst,setStep,_setUsername } = passwordSlice.actions;
export const selectStep = (state: RootState) => state.passwordReducer.step;
export const selectUsername = (state: RootState) => state.passwordReducer.username;

export default passwordSlice.reducer;